import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableStripeCvcRevalidation',
  initialState: false,
  reducers: {
    setEnableStripeCvcRevalidation(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableStripeCvcRevalidation } = slice.actions;

export default slice.reducer;
